import { PageMapper } from 'mapper/PageMapper';

import { pageItemMapper } from './pageItemMapper';

export const pageMapper = new PageMapper(pageItemMapper);
